<template>
  <el-dialog
    title="录播视频上传"
    :visible.sync="showModal"
    width="720px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel">
    <form ref="vcExample">
      <input
        type="file"
        style="display:none;"
        ref="vcExampleVideo"
        accept=".mp4,.MP4"
        @change="setVcExampleVideoName()"
      />
      <input
        type="file"
        style="display:none;"
        ref="vcExampleCover"
        @change="setVcExampleCoverName()"
      />
    </form>


    <div class="row" style="padding:10px;">
      <h2 style="text-align:center"> 上传视频和封面</h2>
      <br/>
      <br/>


      <a style="padding-left:200px;font-size:20px;padding-right:20px;">视频:</a>
      <el-button
        icon="ios-add"
        type="primary"
        @click="vcExampleAddVideo"> {{vcExampleVideoName || '添加视频'}}
      </el-button>
      <br>
      <br>
      <a style="padding-left:200px;font-size:20px;padding-right:20px;">图片:</a>
      <el-button
        icon="ios-add"
        type="primary"
        @click="vcExampleAddCover"> {{vcExampleCoverName || '添加封面'}}
      </el-button>
      <div style="text-align:right">
        <el-button href="javascript:void(0);" class="btn btn-default" @click="vcExampleAddUpload">上传</el-button>
      </div>

    </div>

    <div class="row" id="resultBox">
      <!-- 上传信息组件	 -->
      <div class="uploaderMsgBox" v-for="uploaderInfo in uploaderInfos" :key="uploaderInfo.fileId">
        <div v-if="uploaderInfo.videoInfo">
          <el-tag color="blue"> 视频名称：</el-tag>
          {{uploaderInfo.videoInfo.name + '.' + uploaderInfo.videoInfo.type}}
          <!-- <Tag color="red" > 上传进度：</Tag>  -->
          <el-progress :percentage="Math.floor(uploaderInfo.progress * 100)"/>
          <el-tag color="cyan"> 文件id：</el-tag>
          {{uploaderInfo.fileId}}
          <el-tag color="black"> 上传结果：</el-tag>
          {{uploaderInfo.isVideoUploadCancel ? '已取消' : uploaderInfo.isVideoUploadSuccess ? '上传成功' : '上传中'}}
          <br/>
          <el-tag color="lime"> 地址：</el-tag>
          {{uploaderInfo.videoUrl}}
          <a
            href="javascript:void(0);"
            class="cancel-upload"
            v-if="!uploaderInfo.isVideoUploadSuccess && !uploaderInfo.isVideoUploadCancel"
            @click="uploaderInfo.cancel()"
          >取消上传</a>
          <br/>
        </div>

        <br/>
        <div v-if="uploaderInfo.coverInfo">
          <el-tag color="green"> 封面名称：</el-tag>
          {{uploaderInfo.coverInfo.name}}
          <!-- <Tag color="red" > 上传进度：</Tag>   -->

          <el-progress :percentage="Math.floor(uploaderInfo.coverProgress * 100)"/>
          <el-tag color="black"> 上传结果：</el-tag>
          {{uploaderInfo.isCoverUploadSuccess ? '上传成功' : '上传中'}}
          <br/>
          <el-tag color="lime"> 地址：</el-tag>
          {{uploaderInfo.coverUrl}}
          <br/>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>

import TcVod from "vod-js-sdk-v6";
import request from '@/api/request'

  //例子 上传的需要补充url
  export default {
    data() {
      return {
        showModal: false,
        uploaderInfos: [],
        vcExampleVideoName: "",
        vcExampleCoverName: "",
        cExampleFileId: ""

      };
    },
    methods: {
      init() {
        this.uploaderInfos = [];
        this.vcExampleVideoName = "";
        this.vcExampleCoverName = "";
        this.cExampleFileId = "";
        this.showModal = true;
      },
      ok() {
        //this.$message.info("Clicked ok");
        console.log(this.uploaderInfos, 1234)
        this.$emit('childByValue', this.uploaderInfos)
        this.cancel()
      },
      cancel() {
        this.showModal = false
        // this.$message.info("Clicked cancel");
      },

      setVcExampleVideoName: function () {
        this.vcExampleVideoName = this.$refs.vcExampleVideo.files[0].name;
      },

      setVcExampleCoverName: function () {
        this.vcExampleCoverName = this.$refs.vcExampleCover.files[0].name;
      },

      vcExampleAddVideo: function () {
        this.$refs.vcExampleVideo.click();
      },

      vcExampleAddCover: function () {
        this.$refs.vcExampleCover.click();
      },

      vcExampleAddUpload() {

        var mediaFile = this.$refs.vcExampleVideo.files[0];
        var coverFile = this.$refs.vcExampleCover.files[0];
        if (mediaFile == null) {
          this.$message.info('视频不能为空')
          return;
        }
        if (coverFile == null) {
          this.$message.info('封面不能为空')
          return;
        }
        // 用签名函数触发
        const tcVod = new TcVod({
          getSignature
        });


        // 向业务后台获取签名
        function getSignature() {
          return request({
            url: '/admin/product/oss/adm/getSignature',
            method: 'post'
          }).then(function (response) {
            console.log(response.data.signature)
            return response.data.signature;
          })
        }

        var self = this;


        var uploader = tcVod.upload({
          mediaFile: mediaFile,
          coverFile: coverFile
        });


        uploader.on("media_progress", function (info) {
          uploaderInfo.progress = info.percent;
        });
        uploader.on("media_upload", function (info) {
          uploaderInfo.isVideoUploadSuccess = true;
        });
        uploader.on("cover_progress", function (info) {
          uploaderInfo.coverProgress = info.percent;
        });
        uploader.on("cover_upload", info => {
          uploaderInfo.isCoverUploadSuccess = true;
        });
        console.log(uploader, "uploader");

        var uploaderInfo = {
          videoInfo: uploader.videoInfo,
          coverInfo: uploader.coverInfo,
          isVideoUploadSuccess: false,
          isVideoUploadCancel: false,
          isCoverUploadSuccess: false,
          progress: 0,
          coverProgress: 0,
          fileId: "",
          videoUrl: "",
          coverUrl: "",
          cancel: function () {
            uploaderInfo.isVideoUploadCancel = true;
            uploader.cancel();
          }
        };

        this.uploaderInfos.push(uploaderInfo);

        uploader
          .done()
          .then(doneResult => {
            console.log("doneResult", doneResult);

            uploaderInfo.fileId = doneResult.fileId;

            uploaderInfo.coverUrl = doneResult.cover.url;
            return doneResult.video.url;
          })
          .then(videoUrl => {
            uploaderInfo.videoUrl = videoUrl;
            self.$refs.vcExample.reset();
            self.vcExampleVideoName = "";
            self.vcExampleCoverName = "";
            this.ok()
          });
      }
    }
  };
</script>

